<div *ngIf="initialised">
    <div class="d-flex flex-wrap" *ngIf="showBaseScreen">
        <div class="col-12 col-md-4">
            <h2>Pay in full.</h2>
        </div>
        <div class="col-12 col-md">
            <h4>Select balance/s to be paid<span class="required">*</span></h4>
            <div class="d-flex flex-wrap">
                <div class="col-12" [ngClass]="{'col-md-auto me-2': !isCollexusVersion()}" *ngFor="let account of getDebtAccounts()">
                    <input type="checkbox" [id]="'accountSelect' + account.accountId" kendoCheckBox [checked]="isDebtAccountSelected(account.accountId)"
                        (change)="toggleDebtAccount(account.accountId)" />
                    <kendo-label
                    class="k-checkbox-label"
                    [for]="'accountSelect' + account.accountId"
                    [text]="getDebtAccountDescription(account)">
                    </kendo-label>
                </div>
            </div>
            <p>
                <span class="me-2 bold">Total: {{getSummaryTotal()}}</span>
                <span *ngIf="isPaymentAmountInMethodCurrencyVisible()" class="bold">{{ getTotalAmountInMethodCurrency() | async }}</span>
            </p>
            
            <hr/>
            
            <h4>Payment amount</h4>
            <form class="k-form" #paymentForm="ngForm" novalidate>
                <div class="d-flex align-items-center">
                    <span class="bold">$&nbsp;</span>
                    <kendo-numerictextbox class="input-payment-page" #alternativeAmountInput name="alternativeAmountInput" [(ngModel)]="alternativeAmount" [min]="1"
                        [max]="getAlternativeAmountMaximum()" [autoCorrect]="true" placeholder="How much?" [spinners]="false" [required]="true">
                    </kendo-numerictextbox>
                    <span class="bold">&nbsp;&nbsp;{{getPaymentCurrency()}}</span>
                    <span *ngIf="isPaymentAmountInMethodCurrencyVisible()" class="ms-2">{{ getPaymentAmountInMethodCurrency() | async }}</span>
                </div>
            </form>

            <hr/>
            
            <h4>Payment method</h4>
            <div *ngIf="isCountrySelectVisible()" class="d-flex flex-column mb-2">
                <kendo-label text="Where are you paying from?">
                    <span class="required">*</span>
                </kendo-label>
                <kendo-buttongroup selection="single" class="d-flex flex-wrap">
                    <button *ngFor="let country of getPaymentCountries()" kendoButton class="col-12 col-md-auto me-2" [toggleable]="true" (click)="setPaymentCountry(country)"
                        [selected]="isCountrySelected(country)">
                        {{country}}
                    </button>
                </kendo-buttongroup>
            </div>
            <div class="d-flex flex-column">
                <kendo-label text="How do you wish to pay?">
                    <span class="required">*</span>
                </kendo-label>
                <kendo-buttongroup selection="single" class="d-flex flex-wrap">
                    <button *ngFor="let paymentMethod of getPaymentMethods()" kendoButton class="col-12 col-md-auto me-2" [toggleable]="true"
                        (click)="setPaymentMethod(paymentMethod)" [selected]="isPaymentMethodSelected(paymentMethod)">
                        {{paymentMethod.label}}
                    </button>
                </kendo-buttongroup>
            </div>

            <hr>
            
            <!-- Mobile button -->
            <button kendoButton class="d-inline-block d-md-none button-primary" [disabled]="isNextDisabled()" (click)="onNextClick()">Next</button>
            <button kendoButton class="button-previous me-2" [routerLink]="['/']">Previous</button>
            <!-- Desktop button -->
            <button kendoButton class="d-none d-md-inline-block button-primary" [disabled]="isNextDisabled()" (click)="onNextClick()">Next</button>
        </div>
    </div>

    <div *ngIf="showSummaryScreen" class="d-flex flex-wrap">
        <div class="col-12 col-md-4">
            <h2>{{getSummaryHeading()}}</h2>
        </div>
        <div class="col-12 col-md">
            <div class="confirmation-section confirmation-section-hide-border">
                <div class="section-title" style="border-bottom: none;">Debt/s to be paid</div>
                <div class="section-detail-wrapper">
                    <div class="section-detail-value">
                        {{getSummaryDebts()}}
                    </div>
                </div>
            </div>

            <div class="confirmation-section confirmation-section-hide-border">
                <div class="section-title" style="border-bottom: none;">Total:</div>
                <div class="section-detail-wrapper">
                    <div class="section-detail-value">
                        {{getSummaryTotal()}}
                    </div>
                </div>
            </div>

            <div [ngSwitch]="selectedPaymentMethod">
                <app-manual-summary *ngSwitchCase="'MANUAL'" [summary]="paymentSummary"></app-manual-summary>
                <app-bpay-summary *ngSwitchCase="'BPAY'" [summary]="paymentSummary"></app-bpay-summary>
            </div>

            <div class="d-block d-md-flex mt-2">
                <!-- Mobile button -->
                <button kendoButton class="d-inline-block d-md-none button-primary" (click)="onSummaryNextButtonClick()">
                    Next
                </button>
                <button kendoButton class="button-previous me-2" (click)="onSummaryPreviousButtonClick()">
                    Previous
                </button>
                <!-- Desktop button -->
                <button kendoButton class="d-none d-md-inline-block button-primary" (click)="onSummaryNextButtonClick()">
                    Next
                </button>
            </div>
        </div>
    </div>
</div>